query AutomationEnrollments(
  $id: ID!
  $status: AutomationEnrollmentStatus!
  $nodeId: String
  $after: ID
  $limit: Int
) {
  automationEnrollments(
    id: $id
    status: $status
    nodeId: $nodeId
    after: $after
    limit: $limit
  ) {
    nodes {
      id
      status
      currentNodeId
      waitUntil
      exitReason
      exitRuleId
      createdAt
      finishedAt
      viewer {
        id
        email
        firstName
      }
    }
    nextCursor
  }
}
